<template>
  <div class="mb-3 mt-3">
    <b-container>
      <h1 class="text-primary font-weight-bold text-center mb-5">{{ $t('apiary_edit.title') }}</h1>
      <apiary-form :id="id"></apiary-form>
    </b-container>
  </div>
</template>

<script>
import ApiaryForm from '../components/ApiaryForm'
export default {
  name: 'ApiaryEdit',
  components: { ApiaryForm },
  props: ['id']
}
</script>

<style scoped>

</style>
